import snakecaseKeys from "snakecase-keys";

import type {
  GetPaymentMethodsOptions,
  PaymentData,
  PgsApiContract,
  PgsOrderInput,
  PgsPaymentMethod,
} from "@jti/fe-common";
import { getConfig } from "@jti/fe-common";
import type { LegacyPgsPaymentMethod } from "@jti/rest-api-types";

import { Rest } from "../../Rest";

/** @deprecated Legacy proxy implementation — superseded by EVO. To be deleted after production verification. */
export class PgsApiLegacy extends Rest implements PgsApiContract {
  readonly name = "PgsApi";
  constructor(
    baseUrl: string,
    protected tenantToken: string
  ) {
    super(baseUrl);
    this.setCommonHeader("X-DES-AK-TENANT-TOKEN", this.tenantToken);
  }

  async placeOrder(order: PgsOrderInput): Promise<string> {
    const { payment_token } = await this.request<PaymentData>("/order", {
      body: JSON.stringify(snakecaseKeys(order)),
      method: "PUT",
    });

    return payment_token;
  }

  async getPaymentMethods(options: GetPaymentMethodsOptions = {}): Promise<{ data: PgsPaymentMethod[] }> {
    const skusFilter = options.skus?.length ? `?skus=${options.skus.join(",")}` : "";

    const { data: paymentMethods } = await this.request<LegacyPgsPaymentMethod[]>(`/payment-methods${skusFilter}`, {
      method: "GET",
    });

    const translatedPaymentMethods = paymentMethods.map(({ code, title, ...paymentMethod }) => {
      return {
        ...paymentMethod,
        code,
        title: title ?? "",
        enabled: paymentMethod.enabled ?? true,
      };
    });

    return { data: translatedPaymentMethods };
  }

  async getClient(code: string, locale = getConfig().ISO_COUNTRY_CODE): Promise<string> {
    const { client } = await this.request<{ client: string }>(`/client?payment_method_code=${code}&locale=${locale}`, {
      method: "GET",
    });

    return client;
  }

  async getOrderPaymentMethod(paymentToken: string): Promise<PaymentData> {
    const response = await this.request<PaymentData>(`/payment/${paymentToken}`, {
      method: "GET",
    });
    const { payment_method, title, method, icon, ...paymentMethod } = response;

    const titleResponse = title ?? method?.title;
    const iconResponse = icon ?? method?.icon;

    const translatedPaymentMethod = {
      ...paymentMethod,
      payment_method,
      title: titleResponse ?? "",
      icon: iconResponse,
    };

    return translatedPaymentMethod;
  }
}
